module.exports = __webpack_public_path__ + "assets/images/EURUNFIT100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EURUNFIT100.png
// module id = 1373
// module chunks = 1